<template>
    <div>
        <div v-if="isInDateRange" class="spo-card rounded p-2">
            <div class="text-h6 text-white font-weight-bold rounded-sm px-2 py-1 mb-2"
                style="background-color: #aa156b">Ma
                performance</div>


            <div v-if="loadingTop5" class="d-flex align-center ga-2 my-2">
                <v-progress-circular indeterminate color="primary" size="20" width="2"></v-progress-circular>
                <span class="text-caption text-medium-emphasis">Vérification en cours…</span>
            </div>

            <template v-else>
                <label class="field_label">Performance (km)<span class="text-red">*</span></label>
                <v-text-field v-model.number="performance" type="number" min="0" step="0.01" suffix="km"
                    density="compact" hide-details="auto" :disabled="saving"
                    :error-messages="error ? [error] : []"></v-text-field>

                <div v-if="isTop5" class="mt-4">


                    <label class="field_label">Document justificatif<span class="text-red">*</span></label>
                    <div class="text-caption mb-1">Type de fichiers acceptés : Images, PDF (Max. 2Mo)</div>

                    <div v-if="performance_proof_url"
                        class="d-flex justify-space-between align-center flex-wrap ga-2 mb-2">
                        <v-chip color="dark-green" prepend-icon="mdi-check">
                            <a class="text-dark-green" :href="performance_proof_url" target="_blank">Fichier importé
                                avec succès</a>
                        </v-chip>
                        <v-btn v-if="!changeProof" variant="plain" density="compact" :disabled="saving"
                            @click="changeProof = true">Remplacer le fichier ?</v-btn>
                    </div>

                    <v-file-input v-if="changeProof || !performance_proof_url" density="compact" accept="image/*,.pdf"
                        :disabled="saving" @update:modelValue="uploadProof"></v-file-input>

                    <v-alert v-if="error_size" text="Le fichier ne doit pas dépasser 2Mo" type="error" density="compact"
                        class="mt-1"></v-alert>
                    <v-alert v-if="error_proof" :text="error_proof" type="error" density="compact"
                        class="mt-1"></v-alert>
                </div>
                <div class="d-flex ga-2">
                    <SportipsButton action-button icon="mdi-check" chevron class="my-2" :disabled="saving"
                        @onClick="savePerformance">
                        Enregistrer ma performance
                    </SportipsButton>
                    <SportipsButton action-button icon="mdi-chart-box" chevron class="my-2" @onClick="viewRanking">
                        Consulter le classement
                    </SportipsButton>
                </div>
            </template>
        </div>
        <div v-else class="spo-card rounded p-2">
            <div class="text-h6 text-white font-weight-bold rounded-sm px-2 py-1 mb-2"
                style="background-color: #aa156b">Ma
                performance</div>
            <div>
                Vous pourrez saisir votre performance du 14 au 20 septembre 2026.
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UserService from '@/services/user.service';

export default {
    props: ["inscription"],
    data() {
        return {
            performance: null,
            performance_proof_url: null,
            isTop5: false,
            loadingTop5: true,
            saving: false,
            changeProof: false,
            error: "",
            error_size: false,
            error_proof: "",
        };
    },
    computed: {
        isInDateRange() {
            //entre le 14 et le 20 septembre 2026
            const startDate = new Date("2026-09-14");
            const endDate = new Date("2026-09-20");
            const currentDate = new Date();
            return currentDate >= startDate && currentDate <= endDate;
        },
    },
    methods: {
        viewRanking() {
            this.$router.push({ name: "LCE26Performance" });
        },
        readChampValue(key) {
            const champs = this.inscription?.champs;
            if (!champs || champs[key] === undefined || champs[key] === null) {
                return null;
            }
            const v = champs[key];
            if (typeof v === "object" && v !== null && "value" in v) {
                const s = v.value;
                if (s === "" || s === undefined || s === null) {
                    return null;
                }
                return String(s);
            }
            return String(v);
        },
        initFromInscription() {
            const perf = this.readChampValue("lce26_performance");
            this.performance = perf !== null ? parseFloat(perf) : null;
            this.performance_proof_url = this.readChampValue("lce26_performance_proof_url");
        },
        async checkTop5() {
            this.loadingTop5 = true;
            const res = await UserService.isLCE26Top5Performance(this.performance);
            this.isTop5 = res;
            this.loadingTop5 = false;
        },
        async uploadProof(file) {
            this.error_size = false;
            this.error_proof = "";

            if (!file) {
                return;
            }
            if (file.size > 2000000) {
                this.error_size = true;
                return;
            }

            const data = new FormData();
            data.append("file", file, file.name);
            const res = await axios.post("/coureur/upload_document.php", data);

            if (res.data.error) {
                this.error_proof = res.data.error;
            } else {
                this.performance_proof_url = res.data.url;
                this.changeProof = false;
            }
        },
        async savePerformance() {
            this.error = "";
            this.error_proof = "";

            const perf = parseFloat(this.performance);
            if (!Number.isFinite(perf) || perf <= 0) {
                this.error = "Veuillez saisir une performance supérieure à 0 km.";
                return;
            }

            if (this.isTop5 && !this.performance_proof_url) {
                this.error_proof = "Un document justificatif est obligatoire pour les 5 meilleures performances.";
                return;
            }

            this.saving = true;

            const resPerf = await UserService.updateInscriptionChamp(
                this.inscription.id,
                "lce26_performance",
                String(perf)
            );
            if (!resPerf) {
                this.error = "Erreur lors de l'enregistrement de la performance.";
                this.saving = false;
                return;
            }

            if (this.performance_proof_url) {
                const resProof = await UserService.updateInscriptionChamp(
                    this.inscription.id,
                    "lce26_performance_proof_url",
                    this.performance_proof_url
                );
                if (!resProof) {
                    this.error_proof = "Erreur lors de l'enregistrement du document justificatif.";
                    this.saving = false;
                    return;
                }
            }

            window.location.reload();
        },
    },
    async created() {
        this.initFromInscription();
        await this.checkTop5();
    },
};
</script>

<style lang="scss" scoped></style>
